import {XauditModel} from '../xaudit.model';

export class NotificationConversationDataModel extends XauditModel {
  ConversationID: string;
  SenderUserID: string;
  ReceiverID: string;
}
